import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import FormaPagoCatalogo from '../../support/catalogs/FormaPago';
import MetodoPagoCatalogo from '../../support/catalogs/MetodoPago';
import MonedaPOptions from '../../support/catalogs/complementos/pagos/MonedaPOptions';

const ComprobanteCreationGlobalInfo = (props) => {
  const { data } = props;

  const [rules, setRules] = useState(getRules(data));

  const handleOnChange = (value) => {
    props.onChange(value);
  }

  useEffect(() => {
    setRules(getRules(data));
  }, [data]);

  return (
    <>
      <Row>
        <Col>
          Proporciona los datos generales de tu factura como forma de pago y método de pago.
          <br />
          <br />
          <strong>Nota:</strong> Los campos marcados con * son obligatorios.
        </Col>
      </Row>

      <Row className="pt-3">
        <Col xs="12" sm="6">
          <FormControl type="select"
            label="Método de pago:"
            rows="3"
            name="MetodoPago"
            autoFocus
            placeholder="Método de Pago"
            rules={ rules.MetodoPago }
            value={ data.MetodoPago }
            options={ MetodoPagoCatalogo }
            onChange={ handleOnChange }
          />

          <FormControl type="text"
            label="Condiciones de Pago:"
            rows="3"
            name="CondicionesDePago"
            placeholder="Condiciones de Pago"
            value={ data.CondicionesDePago }
            onChange={ handleOnChange }
          />

          <FormControl type="select"
            label="Forma de Pago:"
            rows="3"
            name="FormaPago"
            placeholder="Forma de Pago"
            rules={ rules.FormaPago }
            value={ data.FormaPago }
            options={ formaPagoCatalogo }
            onChange={ handleOnChange }
          />
        </Col>

        <Col xs="12" sm="6">
          <FormControl type="text"
            label="Transacción Idx: "
            minLength="1"
            maxLength="150"
            name="Idx"
            placeholder="Id de transacción"
            rules={ rules.Idx }
            value={ data.Idx }
            onChange={ handleOnChange }
          />

          <FormControl type="text"
            label="Orden Id:"
            rows="3"
            name="OrdenId"
            placeholder="Id de órden/servicio"
            rules={ rules.OrdenId }
            value={ data.OrdenId }
            onChange={ handleOnChange }
          />

          <FormControl type="datetime-picker"
            id="Fecha"
            rows="3"
            label="Fecha venta/servicio:"
            name="Fecha"
            maxDate={ new Date() }
            rules={ rules.Fecha }
            value={ data.Fecha }
            onChange={ handleOnChange }
          />
        </Col>

      </Row>

      <Row>
        <Col xs="12" sm="6">
          <FormControl
            type="select"
            label="Moneda"
            name="Moneda"
            placeholder=""
            help=""
            rules={ rules.Moneda }
            value={ data.Moneda }
            options={ MonedaPOptions }
            onChange={ handleOnChange }
          />
        </Col>

        <Col xs="12" sm="6">
          <FormControl
            type="number"
            label="Tipo de cambio"
            name="TipoCambio"
            placeholder=""
            help=""
            rules={ rules.TipoCambio }
            value={ data.TipoCambio }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>

      <Row>
        <Col xs="12" sm="6">
          <FormControl type="select"
            label="Exportación"
            name="Exportacion"
            placeholder=""
            help="¿El comprobante ampara una operación de exportación?"
            value={ data.Exportacion }
            options={ exportacionOptions }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>
    </>
  )
}

const formaPagoCatalogo = [{
  value: '',
  label: 'Selecciona forma de pago'
}].concat(FormaPagoCatalogo);

const exportacionOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: 'No aplica',
    value: '01'
  },
  {
    label: 'Definitiva',
    value: '02'
  },
  {
    label: 'Temporal',
    value: '03'
  }
];

const getRules = (data) => {
  return {
    Idx: ['string', 'min:1', 'max:150'],
    OrdenId: ['string', 'min:1', 'max:150'],
    Fecha: [
      'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}\\s[0-9]{2}:[0-9]{2}$/'
    ],
    FormaPago: [
      ['Ingreso', 'Egreso'].indexOf(data.TipoDeComprobante) !== -1 ? 'required' : 'string',
      'in:01,02,03,04,05,06,08,12,13,14,15,17,23,24,25,26,27,28,29,30,31,99'
    ],
    CondicionesDePago: [
        'string',
        'min:1',
        'max:1000',
        'regex:/^[^|]{1,1000}$/um',
    ],
    Moneda: [
        'required',
    ],
    TipoCambio: [
        data.Moneda !== 'MXN' && data.Moneda !== 'XXX' ? 'required' : 'string',
        'decimal:6',
        'min:0.000001',
    ],
    TipoDeComprobante: [
        'required',
        'string',
        'size:1',
        'in:I,E,T,N,P',
    ],
    MetodoPago: [
      ['Ingreso', 'Egreso'].indexOf(data.TipoDeComprobante) !== -1 ? 'required' : 'string',
      'in:PUE,PPD'
    ],
  }
}

export default ComprobanteCreationGlobalInfo;